// @ts-ignore
import LoaderSVG from "~/assets/svg/loader.svg?react";
import * as S from "./styles";

type Props = { fullWidth?: boolean; position?: "fixed" | "absolute" };

const Loader = ({ fullWidth, position }: Props) => {
  return (
    <S.LoaderContainer fullWidth={fullWidth} position={position}>
      <LoaderSVG />
    </S.LoaderContainer>
  );
};

export default Loader;
